import { ExamPaperListPage } from './ExamPaperListPage';
export default ExamPaperListPage;